import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box,
  Tabs, // { added }
  Tab,  // { added }
  TextField,         // <-- added
  InputAdornment,    // <-- added
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DomainIcon from "@mui/icons-material/Domain";
import FeaturesIcon from "@mui/icons-material/Stars";
import SearchIcon from "@mui/icons-material/Search"; // <-- added
import DownloadIcon from "@mui/icons-material/Download"; // <-- new: download icon
import FilterListIcon from "@mui/icons-material/FilterList";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BusinessIcon from "@mui/icons-material/Business";
import Card from "@mui/material/Card";
import {
  getAllUsersTenants,
  changeTenantStatus,
} from "../../../../Services/ClintsApi"; // أضف changeTenantStatus
import { getPlane } from "../../../../Services/plansApi"; // استيراد دالة جلب الخطط
import LinkAppToPlan from "./LinkAppToPlan"; // إضافة استيراد المكون
import { getSupportLogs } from "../../../../Services/ReportsApi"; // <-- استيراد getSupportLogs
import AddCircleIcon from "@mui/icons-material/AddCircle"; // added
import AddFeaturesDialog from "./AddFeatureDialog"; // use dialog from planspage and receive selectedPlanFeatures
import EditIcon from "@mui/icons-material/Edit"; // added
import EditFeatureDialog from "./EditFeatureDialog"; // added (assumes file placed alongside AddFeatureDialog)

const AllVersionTap = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [domainDialog, setDomainDialog] = useState({
    open: false,
    domains: [],
    userName: "",
  });
  const [featuresDialog, setFeaturesDialog] = useState({
    open: false,
    features: [],
    userName: "",
    plane_id: null, // إضافة plane_id هنا
    tenant_id: null, // إضافة tenant_id هنا
  });
  const [linkDialog, setLinkDialog] = useState({
    open: false,
    tenant_id: null,
    userName: "",
  }); // إضافة حالة الحوار
  const [showAddFeatureDialog, setShowAddFeatureDialog] = useState(false); // لإظهار حوار إضافة ميزة
  const [editFeatureDialog, setEditFeatureDialog] = useState({
    open: false,
    feature: null,
  }); // حالة حوار تعديل ميزة
  const [stoppingId, setStoppingId] = useState(null); // حالة لتتبع الإيقاف الجاري
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    tenantId: null,
    userName: "",
    action: "", // 'stop' or 'start'
  });
  const [planesMap, setPlanesMap] = useState({}); // خريطة id -> plane_name
  const [supportLogs, setSupportLogs] = useState([]); // <-- حالة لسجلات الدعم

  // consolidated: filters / tabs / search states (defined once, before any handlers)
  const [activeTab, setActiveTab] = useState(0); // 0 = with plan, 1 = without plan
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [systemStatusFilter, setSystemStatusFilter] = useState("");
  const [versionTypeFilter, setVersionTypeFilter] = useState("");
  const [tenantFilter, setTenantFilter] = useState("");
  // new: plan filter (filter by tenant.plane_id)
  const [planFilter, setPlanFilter] = useState("");
  // new: activator filter (filter by who activated the version)
  const [activatorFilter, setActivatorFilter] = useState("");

  // handlers (ensure handleTabChange is defined)
  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  const handleDateFromChange = (e) => setDateFrom(e.target.value);
  const handleDateToChange = (e) => setDateTo(e.target.value);
  const handleSystemStatusChange = (e) => setSystemStatusFilter(e.target.value);
  const handleVersionTypeChange = (e) => setVersionTypeFilter(e.target.value);
  const handleTenantFilterChange = (e) => setTenantFilter(e.target.value);
  const handlePlanFilterChange = (e) => setPlanFilter(e.target.value);
  const handleActivatorFilterChange = (e) => setActivatorFilter(e.target.value);

  // export visible rows (sortedUsers) to CSV (Excel-compatible)
  const exportToExcel = () => {
    try {
      // headers (match displayed columns)
      const headers = [
        "اسم المستخدم",
        "البريد (مقتطع)",
        "الهاتف",
        "اسم الخطة",
        "تاريخ البداية",
        "تاريخ النهاية",
        "نوع النسخة",
        "حالة النظام",
        "النسخ الاحتياطي",
        "اسم النسخة (tenant_id)",
        "المفعّل (الاسم)",
        "المفعّل (البريد)",
        "عدد الدومينات",
        "عدد الميزات",
      ];

      const rows = sortedUsers.map((u) => {
        const activator = findActivator(u?.tenant?.id || u?.tenant?.tenant_name || u?.tenant?.name) || {};
        return [
          u.name || "",
          getEmailUsername(u.email) || "",
          u.phone || "",
          planesMap[u.tenant?.plane_id] || "",
          u.tenant?.start_date || "",
          u.tenant?.end_date || "",
          u.tenant?.is_demo ? "تجريبية" : u.tenant?.plane_id ? "مدفوعة" : "غير مشترك",
          typeof u.system_status !== "undefined" ? (u.system_status === 1 ? "تعمل" : u.system_status === 0 ? "متوقفة" : String(u.system_status)) : "",
          u.tenant?.database_backup || "",
          u.tenant?.id || "",
          activator.name || "",
          activator.email || "",
          (u.tenant?.domains?.length) || 0,
          (u.tenant?.features?.length) || 0,
        ];
      });

      // build CSV with BOM for Excel UTF-8
      const BOM = "\uFEFF";
      const csvContent =
        BOM +
        [headers, ...rows]
          .map((r) =>
            r
              .map((cell) => {
                if (cell === null || typeof cell === "undefined") return "";
                // escape quotes
                const s = String(cell).replace(/"/g, '""');
                // wrap in quotes if contains comma/newline/quote
                return /[",\n]/.test(s) ? `"${s}"` : s;
              })
              .join(",")
          )
          .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `versions_export_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
    }
  };

  // derive unique tenant options from users
  const tenantOptions = React.useMemo(() => {
    const map = new Map();
    users.forEach((u) => {
      const t = u?.tenant;
      const key = t?.id || t?.tenant_name || t?.name;
      const label = t?.tenant_name || t?.name || t?.id;
      if (key) map.set(String(key), label);
    });
    return Array.from(map.entries()).map(([id, name]) => ({ id, name }));
  }, [users]);

  // derive plan options from planesMap
  const planOptions = React.useMemo(() => {
    return Object.entries(planesMap).map(([id, name]) => ({ id, name }));
  }, [planesMap]);

  // derive activator options from supportLogs (type === 'active_version')
  const activatorOptions = React.useMemo(() => {
    const map = new Map();
    supportLogs.forEach((log) => {
      if (log.type === "active_version" && log.user && log.user.id) {
        map.set(log.user.id, log.user.name || log.user.email || `#${log.user.id}`);
      }
    });
    return Array.from(map.entries()).map(([id, name]) => ({ id, name }));
  }, [supportLogs]);

  const fetchPlanes = async () => {
    try {
      const res = await getPlane();
      const planes =
        res?.data?.data?.palnes || res?.data?.palnes || res?.data?.planes || [];
      const map = {};
      planes.forEach((p) => {
        if (p && typeof p.id !== "undefined") {
          map[String(p.id)] = p.plane_name || p.name || `#${p.id}`;
        }
      });
      setPlanesMap(map);
    } catch (err) {
      console.error("Failed to fetch planes", err);
    }
  };

  // استخراج من useEffect إلى دالة منفصلة لإعادة الجلب
  const fetchUsers = () => {
    setLoading(true);
    getAllUsersTenants()
      .then((res) => {
        setUsers(res.data.users || []);
      })
      .catch(() => setUsers([]))
      .finally(() => setLoading(false));
  };

  // جلب وتحديث قائمة المميزات لـ tenant محدد (يُستخدم بعد إضافة ميزة جديدة)
  const refreshFeaturesForTenant = async (tenantId) => {
    if (!tenantId) return;
    try {
      const res = await getAllUsersTenants();
      const all = res.data?.users || [];
      const found = all.find(
        (u) =>
          String(u?.tenant?.id) === String(tenantId) ||
          String(u?.tenant?.tenant_id) === String(tenantId) ||
          String(u?.tenant?.tenant_name) === String(tenantId)
      );
      const newFeatures = found?.tenant?.features || [];
      setFeaturesDialog((s) => ({ ...s, features: newFeatures }));
    } catch (err) {
      console.error("Failed to refresh features for tenant:", err);
    }
  };

  useEffect(() => {
    fetchUsers(); // استخدام الدالة عند التحميل
    fetchPlanes(); // جلب أسماء الخطط مرة واحدة

    // جلب support logs
    getSupportLogs()
      .then((res) => {
        // قد تكون البنية res.data.data أو res.data
        setSupportLogs(res.data?.data || res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching support logs:", err);
        setSupportLogs([]);
      });
  }, []);

  const handleViewDomains = (domains, userName) => {
    setDomainDialog({ open: true, domains, userName });
  };

  const handleViewFeatures = (features, userName, plane_id, tenant_id = null) => {
    // حفظ plane_id و tenant_id مع بيانات الحوار حتى نتمكن من تمريره إلى AddFeaturesDialog
    setFeaturesDialog({ open: true, features, userName, plane_id, tenant_id });
  };

  const handleCloseDomainDialog = () => {
    setDomainDialog({ open: false, domains: [], userName: "" });
  };

  const handleCloseFeaturesDialog = () => {
    setFeaturesDialog({ open: false, features: [], userName: "", plane_id: null, tenant_id: null });
  };

  const handleOpenLinkDialog = (tenant_id, userName) => {
    setLinkDialog({ open: true, tenant_id, userName });
  };

  const handleCloseLinkDialog = () => {
    setLinkDialog({ open: false, tenant_id: null, userName: "" });
  };

  const handleToggleTenantStatus = async (tenantId) => {
    if (!tenantId) return;
    setStoppingId(tenantId);
    try {
      const res = await changeTenantStatus(tenantId); // API receives tenant_id; server decides toggle/state
      console.log("changeTenantStatus response:", res.data);
      await fetchUsers(); // تحديث البيانات بعد النجاح
    } catch (err) {
      console.error(
        "Error toggling tenant status:",
        err.response?.data || err.message
      );
    } finally {
      setStoppingId(null);
    }
  };

  const openConfirmDialog = (tenantId, userName, action) => {
    setConfirmDialog({ open: true, tenantId, userName, action });
  };

  const closeConfirmDialog = () => {
    setConfirmDialog({ open: false, tenantId: null, userName: "", action: "" });
  };

  const handleConfirmToggle = async () => {
    const id = confirmDialog.tenantId;
    if (!id) return;
    // اغلق الحوار فوراً ثم نفّذ (يمكن إبقاؤه مفتوحًا أثناء التنفيذ إن رغبت)
    closeConfirmDialog();
    await handleToggleTenantStatus(id);
  };

  // دالة لحساب عدد الأيام المتبقية من اليوم حتى التاريخ المعطى
  const getDaysUntil = (dateStr) => {
    if (!dateStr) return null;
    const end = new Date(dateStr);
    const today = new Date();
    const msPerDay = 24 * 60 * 60 * 1000;
    const utcEnd = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    const utcToday = Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    return Math.ceil((utcEnd - utcToday) / msPerDay);
  };

  // Helper: إرجاع الجزء قبل @ من البريد
  const getEmailUsername = (email) => {
    return email ? String(email).split("@")[0] : "";
  };

  // New helper: إيجاد المفعّل بناءً على tenant identifier (id أو name)
  const findActivator = (tenantKey) => {
    if (!tenantKey) return null;
    const log = supportLogs.find(
      (l) =>
        l.type === "active_version" &&
        (l.tenant?.id === tenantKey || l.tenant?.name === tenantKey || l.tenant?.tenant_name === tenantKey)
    );
    return log?.user || null;
  };

  // derived lists
  const withPlan = users.filter((u) => !!u?.tenant?.plane_id);
  const withoutPlan = users.filter((u) => !u?.tenant?.plane_id);
  const selectedUsers = activeTab === 0 ? withPlan : withoutPlan;

  // new: filtered list based on searchQuery and date range
  const filteredUsers = selectedUsers.filter((u) => {
    const q = searchQuery.trim().toLowerCase();

    // apply activator filter
    if (activatorFilter) {
      const activator = findActivator(u?.tenant?.id || u?.tenant?.tenant_name || u?.tenant?.name);
      if (!activator || String(activator.id) !== String(activatorFilter)) {
        return false;
      }
    }

    // apply plan filter
    if (planFilter) {
      if (!u?.tenant?.plane_id || String(u.tenant.plane_id) !== String(planFilter)) {
        return false;
      }
    }

    // apply tenant filter
    if (tenantFilter) {
      const key = u?.tenant?.id || u?.tenant?.tenant_name || u?.tenant?.name;
      if (!key || String(key) !== String(tenantFilter)) return false;
    }

    // apply system status filter
    if (systemStatusFilter !== "" && String(u.system_status) !== String(systemStatusFilter)) {
      return false;
    }
    
    // apply version type filter
    if (versionTypeFilter) {
      const isDemo = !!u?.tenant?.is_demo;
      if (versionTypeFilter === "demo" && !isDemo) return false;
      if (versionTypeFilter === "paid" && isDemo) return false;
    }

    // apply date range filter on tenant created_at or start_date
    if (dateFrom || dateTo) {
      const dateStr = u?.tenant?.created_at || u?.tenant?.start_date;
      if (!dateStr) return false;
      const d = new Date(dateStr);
      if (dateFrom) {
        const from = new Date(dateFrom);
        from.setHours(0,0,0,0);
        if (d < from) return false;
      }
      if (dateTo) {
        const to = new Date(dateTo);
        to.setHours(23,59,59,999);
        if (d > to) return false;
      }
    }

    if (!q) return true;

    const activator = findActivator(u?.tenant?.id || u?.tenant?.tenant_name || u?.tenant?.name);

    const fields = [
      u.name,
      u.email,
      getEmailUsername(u.email),
      u.phone,
      String(u.id),
      u.tenant?.id,
      u.tenant?.tenant_name,
      u.tenant?.name,
      u.tenant?.start_date,
      u.tenant?.end_date,
      planesMap[u.tenant?.plane_id] || "",
      String(u.tenant?.plane_id),
      u.system_status && String(u.system_status),
      activator?.name,
      activator?.email,
    ];

    return fields
      .filter(Boolean)
      .some((f) => String(f).toLowerCase().includes(q));
  });

  // ترتيب المستخدمين بحسب قرب تاريخ النهاية (الأقرب أولاً). بدون تاريخ الإنتهاء تظهر في النهاية
  const sortedUsers = filteredUsers.slice().sort((a, b) => {
    const da = a?.tenant?.end_date ? getDaysUntil(a.tenant.end_date) : Infinity;
    const db = b?.tenant?.end_date ? getDaysUntil(b.tenant.end_date) : Infinity;
    return da - db;
  });
  
  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: '#1976d2' }}>
          قائمة المستخدمين والنسخ
        </Typography>
        <Chip 
          label={`${sortedUsers.length} نسخة`} 
          color="primary" 
          sx={{ fontSize: '1rem', px: 1 }}
        />
      </Box>

     {/* Search and Filters Card */}
     <Card sx={{ p: 3, mb: 3, boxShadow: 3 }}>
       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <FilterListIcon sx={{ mr: 1, color: '#1976d2' }} />
          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            البحث والفلاتر
          </Typography>
        </Box>
        
        {/* Row 1: Search + Export */}
        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="ابحث باسم، بريد، هاتف، معرف النسخة، الخطة أو المفعّل..."
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
               <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
         sx={{ 
           flex: 1, 
           minWidth: 300,
           '& .MuiOutlinedInput-root': {
             '&:hover fieldset': {
               borderColor: '#1976d2',
             },
           },
         }}
        />
        <Button
         variant="contained"
         color="success"
          startIcon={<DownloadIcon />}
          onClick={exportToExcel}
         sx={{ 
           minWidth: 160,
           boxShadow: 2,
           '&:hover': { boxShadow: 4 },
         }}
        >
          تصدير Excel
        </Button>
       </Box>

       {/* Row 2: Status Filters */}
       <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
       <FormControl size="small" sx={{ minWidth: 200, flex: 1 }}>
         <InputLabel>
           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
             <AssignmentIcon fontSize="small" />
             حالة النظام
           </Box>
         </InputLabel>
          <Select
            value={systemStatusFilter}
            onChange={handleSystemStatusChange}
           label="حالة النظام"
          >
            <MenuItem value="">كل الحالات</MenuItem>
            <MenuItem value="1">تعمل</MenuItem>
            <MenuItem value="0">متوقفة</MenuItem>
          </Select>
        </FormControl>

       {/* version type filter */}
       <FormControl size="small" sx={{ minWidth: 200, flex: 1 }}>
         <InputLabel>
           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
             <AssignmentIcon fontSize="small" />
             نوع النسخة
           </Box>
         </InputLabel>
          <Select
            value={versionTypeFilter}
            onChange={handleVersionTypeChange}
           label="نوع النسخة"
          >
            <MenuItem value="">كل الأنواع</MenuItem>
            <MenuItem value="demo">تجريبية</MenuItem>
            <MenuItem value="paid">مدفوعة</MenuItem>
          </Select>
        </FormControl>

       {/* plan filter */}
       <FormControl size="small" sx={{ minWidth: 220, flex: 1 }}>
         <InputLabel>
           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
             <BusinessIcon fontSize="small" />
             اسم الخطة
           </Box>
         </InputLabel>
         <Select value={planFilter} onChange={handlePlanFilterChange} label="اسم الخطة">
            <MenuItem value="">كل الخطط</MenuItem>
            {planOptions.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* tenant (نسخة) filter */}
        <FormControl size="small" sx={{ minWidth: 220, flex: 1 }}>
          <InputLabel>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <PersonIcon fontSize="small" />
              اسم النسخة
            </Box>
          </InputLabel>
          <Select
            value={tenantFilter}
            onChange={handleTenantFilterChange}
           label="اسم النسخة"
          >
            <MenuItem value="">كل النسخ</MenuItem>
            {tenantOptions.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* activator filter */}
        <FormControl size="small" sx={{ minWidth: 220, flex: 1 }}>
          <InputLabel>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <PersonIcon fontSize="small" />
              تم التفعيل بواسطة
            </Box>
          </InputLabel>
          <Select
            value={activatorFilter}
            onChange={handleActivatorFilterChange}
            label="تم التفعيل بواسطة"
          >
            <MenuItem value="">كل المفعّلين</MenuItem>
            {activatorOptions.map((a) => (
              <MenuItem key={a.id} value={a.id}>
                {a.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
       </Box>

       {/* Row 3: Date Filters */}
       <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 200 }}>
         <CalendarTodayIcon fontSize="small" color="action" />
        <TextField
          size="small"
          type="date"
          label="من تاريخ"
          InputLabelProps={{ shrink: true }}
          value={dateFrom}
          onChange={handleDateFromChange}
          fullWidth
        />
       </Box>
        <TextField
          size="small"
          type="date"
          label="إلى تاريخ"
          InputLabelProps={{ shrink: true }}
          value={dateTo}
          onChange={handleDateToChange}
          sx={{ flex: 1, minWidth: 200 }}
        />
       </Box>
      </Card>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
          <CircularProgress size={60} />
        </Box>
      ) : users.length > 0 ? (
        <>
          <Card sx={{ mb: 2, boxShadow: 2, overflow: 'hidden' }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange}
              sx={{
                '& .MuiTabs-indicator': {
                  height: 3,
                  backgroundColor: '#1976d2',
                },
              }}
            >
            <Tab 
              label={`النسخ مع باقة (${withPlan.length})`}
              sx={{
                fontSize: '1rem',
                fontWeight: 600,
                py: 2,
                textTransform: 'none',
              }}
            />
            <Tab 
              label={`النسخ بدون باقة (${withoutPlan.length})`}
              sx={{
                fontSize: '1rem',
                fontWeight: 600,
                py: 2,
                textTransform: 'none',
              }}
            />
          </Tabs>
          </Card>

          <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#1976d2' }}>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>اسم المستخدم</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>البريد الإلكتروني</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>رقم الهاتف</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>اسم الخطة</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>تاريخ البداية</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>تاريخ النهاية</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>نوع النسخة</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>حالة النظام</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>النسخ الاحتياطي</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>تم التفعيل بواسطة</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>الدومين</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>الميزات</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>إجراءات</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedUsers.map((user, index) => {
                  const daysLeft = getDaysUntil(user.tenant?.end_date);
                  const tenantKey =
                    user.tenant?.id ||
                    user.tenant?.tenant_name ||
                    user.tenant?.name;
                  const activator = findActivator(tenantKey);
                  return (
                    <TableRow 
                      key={user.id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? '#fafafa' : 'white',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transition: 'background-color 0.3s',
                        },
                      }}
                    >
                      <TableCell>{user.name}</TableCell>
                      <TableCell>{getEmailUsername(user.email)}</TableCell>
                      <TableCell>{user.phone}</TableCell>
                      <TableCell>
                        {user.tenant?.plane_id ? (
                          planesMap[user.tenant.plane_id] ? (
                            <Chip
                              label={planesMap[user.tenant.plane_id]}
                              size="small"
                              color="info"
                            />
                          ) : (
                            <Chip
                              label={`#${user.tenant.plane_id}`}
                              size="small"
                              color="info"
                            />
                          )
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير محدد
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {user.tenant?.start_date ? (
                          new Date(user.tenant.start_date).toLocaleDateString(
                            "EG"
                          )
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير محدد
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {user.tenant?.end_date ? (
                          <>
                            {new Date(user.tenant.end_date).toLocaleDateString(
                              "EG"
                            )}
                            {typeof daysLeft === "number" &&
                              (daysLeft < 0 ? (
                                <Chip
                                  label="منتهي"
                                  color="error"
                                  size="small"
                                  sx={{ ml: 1 }}
                                />
                              ) : daysLeft <= 7 ? (
                                <Chip
                                  label={`ينتهي خلال ${daysLeft} يوم`}
                                  color="warning"
                                  size="small"
                                  sx={{ ml: 1 }}
                                />
                              ) : null)}
                          </>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير محدد
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {user.tenant?.plane_id ? (
                          <Chip
                            label={user.tenant?.is_demo ? "تجريبية" : "مدفوعة"}
                            size="small"
                            color={user.tenant?.is_demo ? "warning" : "success"}
                          />
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير مشترك
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell>
                        {typeof user.system_status !== "undefined" ? (
                          user.system_status === 0 ? (
                            <Chip label="متوقفة " color="error" size="small" />
                          ) : user.system_status === 1 ? (
                            <Chip label="تعمل " color="success" size="small" />
                          ) : (
                            <Chip
                              label={`حالة (${user.system_status})`}
                              size="small"
                            />
                          )
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير متوفر
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell>
                        {user.tenant?.plane_id ? (
                          user.tenant?.database_backup ? (
                            <Chip
                              label={
                                user.tenant.database_backup === "monthly"
                                  ? "شهري"
                                  : user.tenant.database_backup === "weekly"
                                  ? "أسبوعي"
                                  : user.tenant.database_backup === "daily"
                                  ? "يومي"
                                  : user.tenant.database_backup
                              }
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          ) : (
                            <Typography variant="body2" color="textSecondary">
                              غير محدد
                            </Typography>
                          )
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير مشترك
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {activator ? (
                          <div>
                            <div style={{ fontWeight: 600 }}>{activator.name}</div>
                            <div style={{ fontSize: 12, color: "#666" }}>
                              {getEmailUsername(activator.email)}
                            </div>
                          </div>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            غير متوفر
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Chip
                            label={`${user.tenant?.domains?.length || 0} دومين`}
                            size="small"
                            color="primary"
                          />
                          {user.tenant?.domains?.length > 0 && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleViewDomains(user.tenant.domains, user.name)
                              }
                              sx={{ color: "#1976d2" }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Chip
                            label={`${user.tenant?.features?.length || 0} ميزة`}
                            size="small"
                            color="secondary"
                          />
                          {user.tenant?.features?.length > 0 && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleViewFeatures(
                                  user.tenant.features,
                                  user.name,
                                  user.tenant?.plane_id,
                                  // تمرير tenant identifier (يدعم tenant.id أو tenant.tenant_id)
                                  user.tenant?.id || user.tenant?.tenant_id || null
                                )
                              }
                              sx={{ color: "#9c27b0" }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {user.tenant?.plane_id ? (
                          user.system_status === 1 ? (
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              onClick={() =>
                                openConfirmDialog(
                                  user.tenant?.id,
                                  user.name,
                                  "stop"
                                )
                              }
                              disabled={stoppingId === user.tenant?.id}
                            >
                              {stoppingId === user.tenant?.id ? (
                                <>
                                  <CircularProgress
                                    size={18}
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                  />
                                  جاري التنفيذ...
                                </>
                              ) : (
                                "إيقاف النسخة"
                              )}
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              onClick={() =>
                                openConfirmDialog(
                                  user.tenant?.id,
                                  user.name,
                                  "start"
                                )
                              }
                              disabled={stoppingId === user.tenant?.id}
                            >
                              {stoppingId === user.tenant?.id ? (
                                <>
                                  <CircularProgress
                                    size={18}
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                  />
                                  جاري التنفيذ...
                                </>
                              ) : (
                                "تشغيل النسخة"
                              )}
                            </Button>
                          )
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() =>
                              handleOpenLinkDialog(
                                user.tenant?.id || null,
                                user.name
                              )
                            } // فتح حوار ربط الخطة وتمرير tenant_id
                          >
                            ربط بخطة
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
       ) : (
         <Card sx={{ p: 8, textAlign: 'center', boxShadow: 3 }}>
           <Typography variant="h5" color="text.secondary">
             لا توجد بيانات متوفرة
           </Typography>
         </Card>
       )}

      {/* Domains Dialog */}
      <Dialog
        open={domainDialog.open}
        onClose={handleCloseDomainDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DomainIcon />
          النطاقات - {domainDialog.userName}
        </DialogTitle>
        <DialogContent>
          <List>
            {domainDialog.domains.map((domain) => (
              <ListItem key={domain.id} divider>
                <ListItemText
                  primary={domain.domain}
                  secondary={`تاريخ الإنشاء: ${new Date(
                    domain.created_at
                  ).toLocaleDateString("EG")}`}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDomainDialog}>إغلاق</Button>
        </DialogActions>
      </Dialog>

      {/* Features Dialog */}
      <Dialog
        open={featuresDialog.open}
        onClose={handleCloseFeaturesDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <FeaturesIcon />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>المميزات - {featuresDialog.userName}</span>
              <Chip
                label={`${(featuresDialog.features || []).length} ميزة`}
                size="small"
                color="primary"
                sx={{ ml: 1 }}
              />
            </Box>
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              onClick={() => setShowAddFeatureDialog(true)}
              disabled={!featuresDialog.plane_id} // تعطيل إذا لم توجد باقة مرتبطة
            >
              إضافة ميزة
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <List>
            {featuresDialog.features.map((feature) => (
              <ListItem
                key={feature.id}
                divider
                secondaryAction={
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() =>
                      setEditFeatureDialog({ open: true, feature })
                    }
                    sx={{
                      bgcolor: "#f3e5f5",
                      "&:hover": { bgcolor: "#e1bee7" },
                      ml: 1,
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                }
              >
                <ListItemText
                  primary={feature.name}
                  secondary={
                    <Box sx={{ mt: 1 }}>
                      <Chip
                        label={`شهري: ${feature.pivot?.monthly_cost || 0} جنيه`}
                        size="small"
                        sx={{ mr: 1, mb: 1 }}
                        color="success"
                      />
                      <Chip
                        label={`سنوي: ${feature.pivot?.yearly_cost || 0} جنيه`}
                        size="small"
                        sx={{ mr: 1, mb: 1 }}
                        color="info"
                      />
                      {feature.pivot?.start_date && (
                        <Chip
                          label={`من: ${feature.pivot.start_date} إلى: ${feature.pivot.end_date}`}
                          size="small"
                          variant="outlined"
                        />
                      )}
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseFeaturesDialog}>إغلاق</Button>
        </DialogActions>
      </Dialog>

      {/* AddFeaturesDialog — يفتح عند الضغط على "إضافة ميزة" */}
      <AddFeaturesDialog
        open={showAddFeatureDialog}
        onClose={() => setShowAddFeatureDialog(false)}
        plane_id={featuresDialog.plane_id}
        tenantId={featuresDialog.tenant_id} // <-- هنا نمرر tenant id إلى الديالوج
        selectedPlanFeatures={featuresDialog.features || []}
        onSuccess={async () => {
          // إعادة جلب بيانات الجدول العامة
          await fetchUsers();
          // ثم تحديث قائمة المميزات الظاهرة في الديالوج الحالي دون إغلاقه
          await refreshFeaturesForTenant(featuresDialog.tenant_id);
          setShowAddFeatureDialog(false);
        }}
      />

      {/* EditFeatureDialog — يفتح عند الضغط على أيقونة التعديل بجانب الميزة */}
      <EditFeatureDialog
        open={editFeatureDialog.open}
        onClose={() => setEditFeatureDialog({ open: false, feature: null })}
        feature={editFeatureDialog.feature}
        tenantId={featuresDialog.tenant_id}
        onSuccess={() => {
          // بعد تعديل الميزة أعد جلب البيانات لتعكس التغييرات
          fetchUsers();
          // أغلق الحوارين لعرض التحديث
          setEditFeatureDialog({ open: false, feature: null });
          handleCloseFeaturesDialog();
        }}
      />

      {/* Dialog لربط بخطة */}
      <Dialog
        open={linkDialog.open}
        onClose={handleCloseLinkDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>ربط بخطة - {linkDialog.userName}</DialogTitle>
        <DialogContent>
          <LinkAppToPlan
            tenant_id={linkDialog.tenant_id}
            onClose={handleCloseLinkDialog}
            onSuccess={() => {
              fetchUsers(); // إعادة جلب البيانات بعد النجاح
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLinkDialog}>إغلاق</Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={closeConfirmDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>تأكيد العملية</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            {confirmDialog.action === "stop" ? (
              <Typography>
                هل أنت متأكد من إيقاف النسخة للمستخدم "{confirmDialog.userName}
                "؟
              </Typography>
            ) : (
              <Typography>
                هل أنت متأكد من تشغيل النسخة للمستخدم "{confirmDialog.userName}
                "؟
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeConfirmDialog}
            disabled={stoppingId === confirmDialog.tenantId}
          >
            إلغاء
          </Button>
          <Button
            variant="contained"
            color={confirmDialog.action === "stop" ? "error" : "success"}
            onClick={handleConfirmToggle}
            disabled={stoppingId === confirmDialog.tenantId}
          >
            تأكيد
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AllVersionTap;